export function initCustomersMarquee() {
  const wrapper = document.querySelector('.dcCustomersPreviewRows');
  if (!wrapper) return;

  const ltrRows = Array.from(wrapper.querySelectorAll('.dcCustomersPreviewRow--ltr'));
  const rtlRows = Array.from(wrapper.querySelectorAll('.dcCustomersPreviewRow--rtl'));

  if (!ltrRows.length && !rtlRows.length) return;

  const initRow = (row) => {
    const content = row.querySelector('.dcCustomersPreviewRow__content');
    if (!content) return null;

    content.style.animation = 'none';

    // Only apply scroll marquee if content overflows the row
    const gap = parseFloat(getComputedStyle(content).gap) || 0;
    const children = Array.from(content.children);
    const childrenWidth = children.reduce((sum, el) => sum + el.offsetWidth, 0) + gap * (children.length - 1);

    if (childrenWidth <= row.clientWidth + 1) return null;

    const initialChildren = Array.from(content.children);

    // Capture width of one set BEFORE cloning
    const baseWidth = content.offsetWidth;
    if (baseWidth === 0) return null;

    // Fill row until content is wide enough for seamless looping
    const rowWidth = row.offsetWidth || window.innerWidth;
    const targetWidth = rowWidth + baseWidth * 2;
    let iterations = 0;
    while (content.offsetWidth < targetWidth && iterations < 50) {
      initialChildren.forEach(child => content.appendChild(child.cloneNode(true)));
      iterations++;
    }

    return { content, baseWidth };
  };

  const ltrData = ltrRows.map(initRow).filter(Boolean);
  const rtlData = rtlRows.map(initRow).filter(Boolean);

  // Total horizontal travel while the rows pass the viewport. A fixed 600px
  // was almost two screen widths on phones and felt far too fast there, so
  // scale it with the viewport width and cap it at the desktop value.
  const MAX_MOVEMENT = 600;
  const MOVEMENT_PER_VIEWPORT_WIDTH = 0.45;

  let currentMovement = 0;
  let frameRequested = false;

  const render = () => {
    frameRequested = false;

    ltrData.forEach(({ content, baseWidth }) => {
      const x = currentMovement % baseWidth;
      content.style.transform = `translateX(-${x}px)`;
    });

    rtlData.forEach(({ content, baseWidth }) => {
      const x = currentMovement % baseWidth;
      content.style.transform = `translateX(${x - baseWidth}px)`;
    });
  };

  const updateMovement = () => {
    const rect = wrapper.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    if (rect.top < viewportHeight && rect.bottom > 0) {
      const totalDistance = viewportHeight + rect.height;
      const currentDistance = viewportHeight - rect.top;
      const scrollPercent = currentDistance / totalDistance;
      const maxMovement = Math.min(MAX_MOVEMENT, window.innerWidth * MOVEMENT_PER_VIEWPORT_WIDTH);
      currentMovement = scrollPercent * maxMovement;
    }

    // Only paint when the scroll position changed instead of every frame.
    if (!frameRequested) {
      frameRequested = true;
      requestAnimationFrame(render);
    }
  };

  window.addEventListener('scroll', updateMovement, { passive: true });
  window.addEventListener('resize', updateMovement);

  updateMovement();
}